module.exports = __webpack_public_path__ + "static/media/protoIconWhite.4007e3c5.svg";